import { render, staticRenderFns } from "./ClientInvestmentCard.vue?vue&type=template&id=2ab6f747&"
import script from "./ClientInvestmentCard.vue?vue&type=script&lang=ts&"
export * from "./ClientInvestmentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports